'use client';

import { useState } from 'react';
import { Headset } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { ContactValeDialog } from './contact-vale-dialog';
import { cn } from '@/lib/utils';

export function ContactValeButton({ compact = false }: { compact?: boolean }) {
  const [open, setOpen] = useState(false);

  const button = (
    <Button
      variant="outline"
      size={compact ? 'icon' : 'default'}
      className={cn(
        'hover:bg-accent hover:text-accent-foreground gap-2',
        compact ? 'h-8 w-8' : 'w-full justify-center px-3 text-sm font-normal'
      )}
      onClick={() => setOpen(true)}
    >
      <Headset className="h-4 w-4" />
      {!compact && 'Contact Support'}
    </Button>
  );

  return (
    <>
      {compact ? (
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="right">Contact Support</TooltipContent>
        </Tooltip>
      ) : (
        button
      )}

      <ContactValeDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
